var $8f119aa5de1f3d0e$exports = {};
const $8f119aa5de1f3d0e$var$current = location.pathname.split("/").pop() || "index.html";
const $8f119aa5de1f3d0e$var$links = [
    [
        "index.html",
        "Home"
    ],
    [
        "projects.html",
        "Projects"
    ],
    [
        "cv.html",
        "About / CV"
    ]
];
const $8f119aa5de1f3d0e$var$nav = $8f119aa5de1f3d0e$var$links.map(([href, label])=>`<li><a href="${href}" ${$8f119aa5de1f3d0e$var$current === href ? 'class="active" aria-current="page"' : ""}>${label}</a></li>`).join("");
const $8f119aa5de1f3d0e$var$container = document.getElementById("navbar-container");
if ($8f119aa5de1f3d0e$var$container) {
    $8f119aa5de1f3d0e$var$container.innerHTML = `<header id="main-navbar"><a class="logo" href="index.html"><span class="logo-mark" aria-hidden="true">ac</span>Antonino Cilione</a><nav class="desktop-nav" aria-label="Main"><ul class="nav-links">${$8f119aa5de1f3d0e$var$nav}</ul></nav><button class="theme-toggle" type="button"></button><button class="menu-toggle" type="button" aria-expanded="false" aria-controls="mobile-navigation">Menu</button><nav id="mobile-navigation" class="mobile-nav" aria-label="Mobile"><ul class="nav-links">${$8f119aa5de1f3d0e$var$nav}</ul></nav></header>`;
    const menu = $8f119aa5de1f3d0e$var$container.querySelector(".menu-toggle"), mobile = $8f119aa5de1f3d0e$var$container.querySelector(".mobile-nav");
    const close = ()=>{
        menu.setAttribute("aria-expanded", "false");
        mobile.classList.remove("open");
    };
    menu.addEventListener("click", ()=>{
        const open = menu.getAttribute("aria-expanded") !== "true";
        menu.setAttribute("aria-expanded", String(open));
        mobile.classList.toggle("open", open);
    });
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape" && mobile.classList.contains("open")) {
            close();
            menu.focus();
        }
    });
    mobile.querySelectorAll("a").forEach((a)=>a.addEventListener("click", close));
    const themeButton = $8f119aa5de1f3d0e$var$container.querySelector(".theme-toggle");
    const update = ()=>{
        const dark = document.documentElement.dataset.theme === "dark";
        themeButton.textContent = dark ? "Light mode \u2197" : "Dark mode \u2197";
        themeButton.setAttribute("aria-label", dark ? "Switch to light theme" : "Switch to dark theme");
    };
    update();
    themeButton.addEventListener("click", ()=>{
        const theme = document.documentElement.dataset.theme === "dark" ? "light" : "dark";
        document.documentElement.dataset.theme = theme;
        try {
            localStorage.setItem("theme", theme);
        } catch  {}
        update();
    });
}


//# sourceMappingURL=acilione.github.io.238d4610.js.map
